import { createApi } from '@reduxjs/toolkit/query/react';

import { fetchbase } from './apis.util';

export const baseApi = createApi({
  baseQuery: fetchbase,

  refetchOnFocus: false,

  refetchOnMountOrArgChange: 60,

  tagTypes: [
    'Buildings',
    'Building',
    'Zones',
    'Zone',
    'ZoneCategories',
    'ZoneCategoryServiceItems',
    'ZoneServiceItems',
    'CurrentUser',
    'Employees',
    'Users',
    'AssignedBuildings',
    'UserNotifications',
    'GetDecal',
    'Onboarding',
    'ScansCount',
    'SubscribersCount',
    'ScheduleProgress',
    'ServiceInterruptions',
    'ItemsInCart',
    'ItemsInCartCount',
    'RatingSummary',
    'TotalFeedbackReceived',
    'CategoryRatingExtremes',
    'AreaRatingExtremes',
    'CleaningHistory',
  ],

  endpoints: () => ({}),
});
